import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import { ResetFiltersSvg } from '@assets';
import { IconButtonTooltip } from '@components';
import { useAppSelector } from '@hooks';

interface IResetFiltersButton {
  isLoading: boolean;
  clearFilters: () => void;
}

export const ResetFiltersButton = ({
  isLoading,
  clearFilters,
}: IResetFiltersButton) => {
  const mode = useAppSelector((state) => state.appConfig.config.mode);
  const theme = useTheme();
  const isDarkMode = mode === 'dark';

  return (
    <IconButtonTooltip
      disableInteractive
      title="common.grid.button.tooltip.reset.orbit"
    >
      <IconButton
        disableRipple
        sx={{
          width: '2.5rem',
          height: '2.5rem',
          background: theme.palette.primary.contrastBackground,
          '&:hover': {
            boxShadow: theme.customShadows.iconButton,
            background: isDarkMode ? 'transparent' : theme.palette.common.white,
            '& svg': {
              '& circle': { fill: theme.palette.error.darker },
            },
          },
        }}
        color="inherit"
        component="span"
        disabled={isLoading}
        edge="start"
        onClick={clearFilters}
      >
        <ResetFiltersSvg />
      </IconButton>
    </IconButtonTooltip>
  );
};
